export const FIRM_GLOBAL_VIEW = "firmGlobalView"

export const canAddItem = ( table: string ): boolean => {
	return table != FIRM_GLOBAL_VIEW && table != "calendar" && table != "activity"
}